"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legalConsentDefaultSettings = legalConsentDefaultSettings;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {};

function legalConsentDefaultSettings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.RECEIVE_LEGAL_CONSENT_SETTINGS:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}